import { Component, Input } from "@angular/core";

export type DsCardAlign = "center" | "top-left" | "top-right" | "bottom-left" | "bottom-right";

@Component({
  selector: "ds-card",
  templateUrl: "./ds-card.component.html",
  styleUrls: ["./ds-card.component.scss"],
})
export class DsCardComponent {
  @Input() disabled = false;
  @Input() loading = false;
  @Input() align: DsCardAlign = "center";
  @Input() hideFocusHighlight = false;

  constructor() {}
}
